import React from "react";
import { getPriceCurrencies } from "utils/price";
import Select from "components/Form/fields/Select";
const DEFAULT_CLASSES = {
  container: "pt3 flex flex-row justify-between items-center"
};
const PricesCurrencySelect = ({
  prices,
  value,
  setActiveCurrency,
  hideLabel,
  customClasses,
  selectProps
}) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const priceCurrency = getPriceCurrencies(prices);
  if (priceCurrency.length > 0) {
    const selectFieldProps = {
      options: priceCurrency.map((cur) => ({
        uid: cur,
        label: cur.toUpperCase()
      })),
      value,
      disabled: priceCurrency.length === 1,
      onChange: (key) => (evt) => {
        const selection = evt.currentTarget.value;
        setActiveCurrency(selection);
      },
      ...selectProps
    };

    return (
      <div className={classes.container}>
        {!hideLabel && <label className="f6 fw5 db">Currency</label>}
        <div className="flex-shrink-0 w3">
          <Select {...selectFieldProps} />
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default PricesCurrencySelect;
